interface Props { tag: string; className?: string }

const DiscountTag = ({ tag, className = '' }: Props) => {
    return (
        <span className={`inline-flex items-center gap-0.5 text-[9px] font-black px-1.5 py-0.5 rounded-md shadow-sm tracking-tight ${className}`}
            style={{ background: '#FF9934', color: '#ffffff' }}>
            {tag}
        </span>
    )
}

export default DiscountTag
